// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JPoTk{display:flex;align-items:center;gap:8px}.JPoTk.F6TTK{gap:6px}.V6I6j{display:flex;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JPoTk`,
	"mobile": `F6TTK`,
	"additionalBlock": `V6I6j`
};
export default ___CSS_LOADER_EXPORT___;
